export default __webpack_public_path__ + "static/media/CV-MMP.d5fac4ab.pdf";